import { StrategyDuration, TokenListMetadata, ClmmPositionExpanded } from "@bridgesplit/abf-sdk";

export enum LoopMode {
    Auto = "auto",
    Manual = "manual"
}

export enum ManualLoopMode {
    InputPrincipal = "InputPrincipal",
    InputCollateral = "InputCollateral",
    InputLtv = "InputLtv"
}

export interface WindForm {
    inputAmount: number | undefined;
    multiplier: number | undefined;
    multiplierWithoutDebounce: number | undefined;
    strategyDuration: StrategyDuration;
    percentSlippageDecimals: number | undefined;
    inputToken: TokenListMetadata | undefined;
    clmmPosition?: ClmmPositionExpanded | undefined;
    // Manual mode fields (deposit collateral, borrow principal)
    collateralAmount?: number | undefined;
    principalAmount?: number | undefined;
    ltvMultiplier: number; // For manual mode LTV slider
    manualMode: ManualLoopMode; // Track which input is driving the calculation
}
